<template>
  <div v-if="loading" class="text-center text-primary my-2">
    <b-spinner type="grow" class="align-middle"></b-spinner>
  </div>
  <div v-else>
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-group" v-if="!branchData">
          <label for="name-rule">{{
            $t('menu.settings.alertsNewsletters.labels.ruleName')
          }}</label>
          <input
            id="name-rule"
            type="text"
            class="form-control"
            :placeholder="
              $t('menu.settings.alertsNewsletters.placeholderRuleName')
            "
            v-model="newRule.name"
          />
          <div class="invalid-feedback">
            {{ $t('menu.settings.alertsNewsletters.feedbackRuleName') }}
          </div>
        </div>
      </div>
    </div>
    <hr v-if="!branchData" />
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-group" v-if="!branchData">
          <b-form-checkbox
            v-model="newRule.expirationActive"
            name="check-button"
            switch
          >
            Dias para expiração
            <span class="header-icon" id="info-date-expiration"
              ><font-awesome-icon :icon="['fas', 'info-circle']"
            /></span>
          </b-form-checkbox>
          <input
            id="expire"
            type="number"
            class="form-control mt-2"
            placeholder="Expira em"
            v-model="newRule.expiresInDays"
          />
        </div>

        <b-popover
          target="info-date-expiration"
          triggers="hover"
          placement="top"
        >
          <template #title>Dias para expiração</template>
          <p>
            Quando habilitado "Dias para expiração" e definido a quantidade de
            dias para expirar, após a resposta entrar no sistema passa a valer o
            tempo escolhido para expirar a tratativa daquela resposta. Ao
            ultrapassar o tempo configurado, o status passa a ser expirado.
          </p>
          <p><strong>Obs: Aplicado na ação que possui a regra.</strong></p>
        </b-popover>
      </div>
    </div>
    <hr v-if="!branchData" />
    <p>
      <strong>{{ $t('menu.settings.alertsNewsletters.alertNote') }}</strong>
    </p>
    <div v-for="(rule, i) in newRule.rules" :key="i">
      <div class="row">
        <div class="col-12 emails-area">
          <div class="form-group input-email mr-3">
            <label :for="`email-${i}`">{{
              $t('menu.settings.alertsNewsletters.labels.email')
            }}</label>
            <input
              :id="`email-${i}`"
              type="text"
              class="form-control"
              v-model="rule.email"
              :placeholder="$t('menu.settings.alertsNewsletters.feedbackEmail')"
            />

            <div class="invalid-feedback">
              {{ $t('menu.settings.alertsNewsletters.feedbackEmail') }}
            </div>
          </div>
          <template v-if="type === 'ces-1-5'">
            <div class="grade-checkbox-section mr-3">
              <div
                v-for="alert in rule.alerts"
                :key="alert.grade"
                class="grade-checkbox"
              >
                <b-form-checkbox
                  :id="`${alert.grade}-${i}`"
                  v-model="alert.value"
                  class="check-alert-modal ml-3"
                >
                </b-form-checkbox>
                <label :for="`${alert.grade}-${i}`" class="ml-1">{{
                  alert.grade
                }}</label>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="grade-checkbox-section mr-3">
              <div
                v-for="alert in rule.alerts"
                :key="alert.grade"
                class="grade-checkbox"
              >
                <b-form-checkbox
                  :id="`${alert.grade}-${i}`"
                  v-model="alert.value"
                  class="check-alert-modal ml-3"
                >
                </b-form-checkbox>
                <label :for="`${alert.grade}-${i}`" class="ml-1">{{
                  alert.grade
                }}</label>
              </div>
            </div>
          </template>

          <div>
            <button @click="addNewEmail" class="btn btn-outline-primary">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </button>
            <button @click="removeEmail(i)" class="btn btn-outline-danger">
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <div class="custom-switch">
            <input
              type="checkbox"
              class="custom-control-input just-comment"
              :id="`just-comment-type-${i}`"
              v-model="rule.justComment"
            />
            <label
              class="custom-control-label mt-2"
              :for="`just-comment-type-${i}`"
              >{{
                $t('menu.settings.alertsNewsletters.labels.onlyReplyComment')
              }}</label
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <div class="custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              :id="`select-all-geral-${i}`"
              @click="selectAllNotesGeral($event, i)"
            />
            <label :for="`select-all-geral-${i}`" class="custom-control-label"
              >Selecionar todas as notas
            </label>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <p>
      <strong>{{ $t('menu.settings.alertsNewsletters.staggering') }}</strong>
    </p>
    <div class="row mb-4">
      <div class="col-12">
        <div class="row">
          <div class="col-10">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.levelOneEmail')
            }}</label>
            <input
              type="text"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.alertsNewsletters.placeholderStaggering',
              )}`"
              v-model="newRule.level1.email"
            />
          </div>
          <div class="col-2">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.days')
            }}</label>
            <input
              type="number"
              class="form-control"
              placeholder="0"
              v-model="newRule.level1.days"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-10">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.levelTwoEmail')
            }}</label>
            <input
              type="text"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.alertsNewsletters.placeholderStaggering',
              )}`"
              v-model="newRule.level2.email"
            />
          </div>
          <div class="col-2">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.days')
            }}</label>
            <input
              type="number"
              class="form-control"
              placeholder="0"
              v-model="newRule.level2.days"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-10">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.levelThreeEmail')
            }}</label>
            <input
              type="text"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.alertsNewsletters.placeholderStaggering',
              )}`"
              v-model="newRule.level3.email"
            />
          </div>
          <div class="col-2">
            <label for="">{{
              $t('menu.settings.alertsNewsletters.labels.days')
            }}</label>
            <input
              type="number"
              class="form-control"
              placeholder="0"
              v-model="newRule.level3.days"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert';
import EventBus from '../../../../../../eventBus';

export default {
  data: () => ({
    userAuth: null,
    loading: true,
    initialDataConfiguration: null,
    errorMessage: null,
    type: null,
  }),
  props: ['actionId', 'branchData'],

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.initialDataConfiguration = this.$data;
  },

  async mounted() {
    EventBus.$on('registerNewRule', async (modal) => {
      if (this.validateFields(modal)) {
        if (!this.newRule._id) {
          await this.saveRule({
            companyId: this.userAuth.companyId,
            actionId: this.actionId,
            token: this.userAuth.token,
            data: this.newRule,
          });

          Object.assign(this.$data, this.$options.data.call(this));

          this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

          await this.setList({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
          });

          this.action.alertRules.id = this.alertId;

          this.loading = false;

          swal(
            this.$t(
              'menu.settings.alertsNewsletters.messages.successRegisterRule.title',
            ),
            this.$t(
              'menu.settings.alertsNewsletters.messages.successRegisterRule.description',
            ),
            'success',
          );

          this.$bvModal.hide('modal-new-rule');
        } else {
          await swal(
            '',
            this.$t('menu.settings.alertsNewsletters.messages.ruleRegistered', {
              newRuleName: this.newRule.name,
            }),
            'warning',
          );
          this.$bvModal.hide('modal-new-rule');
        }
      } else {
        swal('Oops!', this.errorMessage, 'error');
      }

      EventBus.$emit('loadingNewRule');
    });

    this.changeEmailGrades(this.myMetric);

    this.loading = false;
  },

  computed: {
    ...mapState('settings', ['companyAllUsers']),
    ...mapState('actions', ['action']),
    ...mapState('alertRules', ['alertId', 'newRule', 'myRule']),
    ...mapState('companies', ['myMetric']),

    teste() {
      return false;
    },
  },

  watch: {
    switchPromoters: function watchPromoters(value) {
      if (value === false) {
        this.newRule.designated.promoters = 'none';
      }
    },

    switchNeutral: function watchNeutral(value) {
      if (value === false) {
        this.newRule.designated.neutral = 'none';
      }
    },

    switchDetractors: function watchDetractors(value) {
      if (value === false) {
        this.newRule.designated.detractors = 'none';
      }
    },
    myMetric: function myMetric(value) {
      this.changeEmailGrades(value)
    },
  },

  methods: {
    ...mapActions('settings', ['getAllUsers']),
    ...mapActions('alertRules', ['saveRule', 'setList']),
    ...mapActions('actions', ['updateAction']),

    selectAllNotesGeral(event, index) {
      if (event.target.checked === true)
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.newRule.rules[index].alerts.length; i++) {
          this.newRule.rules[index].alerts[i].value = true;
        }

      if (event.target.checked === false) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.newRule.rules[index].alerts.length; i++) {
          this.newRule.rules[index].alerts[i].value = false;
        }
      }
    },

    addNewEmail() {
      if (
        this.myMetric === 'ces-1-5' ||
        this.myMetric === 'csat-1-5' ||
        this.myMetric === 'nps-1-5' ||
        this.myMetric === 'csat-1-5(media)' ||
        this.myMetric === '5-stars'
      ) {
        this.newRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
          ],
        });
      } else if (this.myMetric === 'like-dislike') {
        this.newRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 0, value: false },
            { grade: 1, value: false },
          ],
        });
      } else {
        this.newRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 0, value: false },
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
            { grade: 6, value: false },
            { grade: 7, value: false },
            { grade: 8, value: false },
            { grade: 9, value: false },
            { grade: 10, value: false },
          ],
        });
      }
    },

    removeEmail(index) {
      if (this.newRule.rules.length > 1) {
        this.newRule.rules.splice(index, 1);
      }
    },

    validateFields(modal) {
      if (!this.newRule.name) {
        this.errorMessage = this.$t(
          'menu.settings.alertsNewsletters.messages.pleaseInsertNameRule',
        );

        if (modal) {
          modal.preventDefault();
        }

        return false;
      }

      const validate = true;

      if (!validate) {
        if (modal) {
          modal.preventDefault();
        }
        return false;
      }

      return true;
    },

    changeEmailGrades(value) {
      switch (value) {
        case 'ces-1-5':
        case 'csat-1-5':
        case 'csat-1-5(media)':
        case 'nps-1-5':
        case '5-stars':
          this.$store.state.alertRules.newRule.rules[0].alerts = [
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
          ];
          break;
        case 'like-dislike':
          this.$store.state.alertRules.newRule.rules[0].alerts = [
            { grade: 0, value: false },
            { grade: 1, value: false },
          ];
          break;
        case 'nps-0-10':
        case 'csat-0-10(media)':
          this.$store.state.alertRules.newRule.rules[0].alerts = [
            { grade: 0, value: false },
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
            { grade: 6, value: false },
            { grade: 7, value: false },
            { grade: 8, value: false },
            { grade: 9, value: false },
            { grade: 10, value: false },
          ];
          break;
        default:
          break;
      }
    },
  },

  beforeDestroy() {
    EventBus.$off('registerNewRule');
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.header-icon {
  color: $gray;
}

.emails-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .input-email {
    flex: 1;
  }

  .grade-checkbox-section {
    display: flex;
    align-items: center;
  }

  .grade-checkbox {
    width: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/new-rule/tab-geral/index.vue